// Decision I-3: both /inbox and /inbox/$id render the same InboxShell.
// selectedId comes from the URL param; the shell handles responsive layout.
import { createFileRoute } from '@tanstack/react-router';
import { InboxShell } from '@/components/inbox/InboxShell';

export const Route = createFileRoute('/_app/inbox/$id')({
  component: InboxDetailRoute,
});

function InboxDetailRoute() {
  const { id } = Route.useParams();
  return <InboxShell selectedId={id} />;
}
